<template>
  <div class="px-[24px] h-screen flex flex-col justify-center">
    <div class="">
      <Spinner
        v-if="loading"
        fill="currentColor"
        :class="['mx-auto mt-4', spinnerColorClass]"
        style="width: 84px; height: 84px"
      />

      <template v-else>
        <div
          v-if="hasError"
          class="p-3 shadow-sm rounded-sm text-sm w-full bg-alert-0 text-white my-2 text-center"
        >
          {{ $t('error') }}
        </div>

        <template v-else>
          <CheckCircleIcon class="mx-auto" />

          <StrongTitle class="mt-5">
            {{ $t('email_verify_success_title') }}
          </StrongTitle>

          <div class="mt-5 text-center">
            {{ $t('email_verify_success_success') }}
          </div>

          <BaseButton
            class="mt-5"
            @click="goToApp"
          >
            {{ $t('continue') }}
          </BaseButton>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import BaseButton from '@/components/buttons/BaseButton.vue'
import StrongTitle from '@/components/ui/StrongTitle.vue'
import CheckCircleIcon from '@/assets/icons/CheckCircleIcon.vue'
import Spinner from '@/components/loading/Spinner.vue'
import { useRoute } from 'vue-router'
import { verifyEmail } from '@/services/api/Auth'
import { redirectToAppUrl } from '@/services/auth/Auth.service'
import { isGuardian, isPets } from '@/comp/AppType'

const route = useRoute()

const confirmationCode = route.params.confirmationCode

const loading = ref(true)
const hasError = ref(false)
const spinnerColorClass = computed(() => {
  if (isPets.value) return 'text-pets-primary-1'
  if (isGuardian.value) return 'text-guardian-secondary-0'

  return 'text-primary-0'
})

const goToApp = () => {
  redirectToAppUrl()
  // router.push({name: ROUTE_NAMES.LOGIN})
}

const verifyEmailAction = async () => {
  loading.value = true

  const { error } = await verifyEmail(confirmationCode)

  loading.value = false
  if (error.value) return (hasError.value = true)
}

verifyEmailAction()
</script>
